import {RootState} from '../../store';

const getSessionIdSelector = (state: RootState) => {
  return state.session.sessionDetails?.id;
};

export {getSessionIdSelector};
